{
  "appointment-history-page": {
    "text": {
      "in-the-past": "Trong quá khứ hoặc bị hủy",
      "no-appointment": "Bạn chưa đặt lịch hẹn nào cả!",
      "upcoming": "Cuộc hẹn sắp tới"
    },
    "meta": {
      "title": "Lịch hẹn",
      "description": "Danh sách các lịch hẹn đã đặt"
    }
  }
}
